/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-unused-modules */
export const { VITE_PORT } = import.meta.env;
export const { VITE_ROUTER_BASENAME } = import.meta.env;
export const VITE_ENV = import.meta.env.VITE_ENV
  ? import.meta.env.VITE_ENV
  : (window as any).VITE_ENV;
export const VITE_BASE_URL = import.meta.env.VITE_BASE_URL
  ? import.meta.env.VITE_BASE_URL
  : (window as any).VITE_BASE_URL;
export const { VITE_AZURE_AUTH_CLIENT_ID } = import.meta.env;
export const { VITE_AZURE_AUTH_TENANT_ID } = import.meta.env;
